export type AuthMode = 'simulada' | 'entra';
export type AuthModeResuelto = AuthMode | 'error';

export interface AuthConfigResuelto {
  modo: AuthModeResuelto;
  errorConfiguracion?: string;
}

export interface ResolveAuthConfigInput {
  modo?: string;
  environment: 'dev' | 'qa' | 'uat' | 'prod';
}

function errorConfiguracion(mensaje: string): AuthConfigResuelto {
  return { modo: 'error', errorConfiguracion: mensaje };
}

/**
 * FE-86: el backend es el cliente de Entra ID (enmienda E-7), así que el modo `entra` ya no
 * exige ninguna variable adicional en la consola (antes pedía client id/tenant/scope para MSAL).
 * Un valor de `VITE_AUTH_MODE` que no sea ni `simulada` ni `entra` es un error de configuración
 * explícito: ya no cae en silencio a `simulada` (ese comportamiento ocultaba un typo en la
 * variable de ambiente detrás del modo por defecto).
 */
export function resolveAuthConfig(input: ResolveAuthConfigInput): AuthConfigResuelto {
  const valor = input.modo?.trim();

  if (!valor || valor === 'simulada') {
    if (input.environment === 'prod') {
      return errorConfiguracion('El modo simulada no puede habilitarse en producción: configura VITE_AUTH_MODE=entra.');
    }
    return { modo: 'simulada' };
  }

  if (valor === 'entra') {
    return { modo: 'entra' };
  }

  return errorConfiguracion(`VITE_AUTH_MODE="${valor}" no es válido: usa "simulada" o "entra".`);
}
